/**
 * Disclosure subscriptions — Phase 5 replacement.
 * The `disclosures` collection is part of `reports` (productType.value === 'disclosure').
 * Delegates to /api/reports endpoints on dash-api.
 */

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token
        ? {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json'}
        : {'Content-Type': 'application/json'};
}

async function apiFetch(path, opts = {}) {
    const resp = await fetch(`${BASE}${path}`, {headers: authHeaders(), ...opts});
    if (resp.status === 404) return null;
    if (!resp.ok) throw new Error(`${opts.method || 'GET'} ${path} → ${resp.status}`);
    return resp.json();
}

export const subscribeToUserDisclosuresForReview = (userId, onChange, onError) => {
    if (!userId) {
        Promise.resolve().then(() => onChange?.([]));
        return () => {};
    }
    let cancelled = false;
    apiFetch('/api/reports?productType=disclosure&status=Awaiting+Review')
        .then((data) => { if (!cancelled) onChange?.(Array.isArray(data) ? data : []); })
        .catch((err) => {
            console.error('subscribeToUserDisclosuresForReview error', err);
            if (!cancelled) onError?.(err);
        });
    return () => { cancelled = true; };
};
